import React from 'react'
import CardButton from '../buttons/_card_button'

function CardOption( {numQuest, question, object=[{}], handleClickSequence,class_center=''} ) {

    return (
        <div className="card__option--container">
            <div className="option__header">
                <h1> {question} </h1>
            </div>
            <div className={`option__content ${class_center}`}>
                {
                    object.map((element,_key) => {
                        return(
                            <div className="card__click"  key={`${numQuest}-${_key}`} onClick={() => handleClickSequence(element.selected)}>
                                <CardButton image={element.image} bodyTitle={ element.bodyTitle} bodyDesc={element.bodyDesc} />
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default CardOption